<template>
  <div id="emailEvents">
    <div class="container-fluid">
      <div class="row">
        <div
          role="main"
          class="col d-block pt-2"
        >
          <section class="pt-3">
            <div class="section-title">
              Unindexed URL Inspection Results
            </div>
          </section>
          <section class="d-flex justify-content-between mb-2">
            <div>
              <div
                class="btn-group"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="getResults(false)"
                >
                  Refresh
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="loadMore"
                >
                  Load More
                </button>
              </div>
            </div>
            <div>
              <p class="m-0 text-muted">
                {{ results.length }} Loaded
              </p>
            </div>
          </section>
          <section
            id="result-container"
            class="table-responsive"
          >
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>URLs Inspected</th>
                  <th>Newly Indexed</th>
                  <th>Error</th>
                  <th>Date Created</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="r in results"
                  :key="r.id"
                >
                  <td>{{ r.id }}</td>
                  <td>{{ r.result.urlCount }}</td>
                  <td>{{ r.result.newlyIndexedURLs }}</td>
                  <td>{{ r.error }}</td>
                  <td>{{ new Date( r.createdAt ).toLocaleDateString() }} @ {{ new Date( r.createdAt ).toLocaleTimeString() }}</td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../../../../http';
import notify from '../../../../notifications';

export default {
    data() {
        return {
            results: [],
            form: {
                take: 25
            }
        };
    },
    methods: {
        async loadMore() {
            await this.getResults( true );
        },
        async getResults( loadNextPage = false ) {
            this.$store.dispatch( 'appLoading', true );

            const params = new URLSearchParams();
            params.set( 'take', this.form.take );

            if ( loadNextPage ) {
                params.set( 'offset', this.results.length );
            }

            const response = await http.get( '/unindexed-urls/results?' + params.toString() );

            if ( response.status != 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    title: 'error occured',
                    text: 'please try again later'
                } );
                return;
            }

            const results = ( await response.json() || [] );

            if ( loadNextPage ) {
                this.results = [
                    ...this.results || [],
                    ...results || []
                ];
            } else {
                this.results = results || [];
            }

            this.$store.dispatch( 'appLoading', false );
        }
    },
    mounted() {
        this.getResults( false );
        document.title = 'thinkSPAIN - Unindexed URL Inspection Results';
    }
};
</script>
  <style>
    #result-container {
      max-height: 500px;
    }

    #result-container th {
      white-space: nowrap;
    }
  </style>



// WEBPACK FOOTER //
// src/components/dashboard/gsc/unindexed-urls/ViewInspectionResults.vue